import React from "react";
import {
  Button,
  Col,
  Modal,
  Row,
  Image,
  ListGroup,
  ProgressBar,
  Table,
} from "react-bootstrap";
const Case3 = ({
  isExpanded,
  lensDataArray,
  framebox,
  handleBack2,
  setIsExpanded,
  SetId,
  Handleform3,
  product,
}) => {
  return (
    <>
      {isExpanded && (
        <Col
          md={2}
          className='sliding-column d-flex flex-column justify-content-center'
        >
          <h4 className='text-center'>Lens Properties</h4>
          <Table striped bordered hover variant='dark'>
            <tbody>
              {lensDataArray[0].lensTable.map((row, index) => (
                <tr key={index}>
                  <td
                    className='text-center'
                    style={{ verticalAlign: "middle" }}
                  >
                    {row.column1}
                  </td>
                  <td
                    className='text-center'
                    style={{ verticalAlign: "middle" }}
                  >
                    {typeof row.column2 === "boolean"
                      ? row.column2
                        ? "✅"
                        : "❌"
                      : row.column2}
                  </td>
                </tr>
              ))}
              {/*  ye table ayega jab framelens mein lens specification daal denge tab catalogue se ayega */}
              {/* {framebox
              .filter((product) => product._id === Id)
              .map((filteredProduct) =>
                filteredProduct.lensTable.map((row, index) => (
                  <tr key={index}>
                    <td
                      className='text-center'
                      style={{ verticalAlign: "middle" }}
                    >
                      {row.column1}
                    </td>
                    <td
                      className='text-center'
                      style={{ verticalAlign: "middle" }}
                    >
                      {typeof row.column2 === "boolean"
                        ? row.column2
                          ? "✅"
                          : "❌"
                        : row.column2}
                    </td>
                  </tr>
                ))
              )} */}
            </tbody>
          </Table>
        </Col>
      )}

      <Col className='shadow' md={isExpanded ? 6 : 8}>
        <ProgressBar
          className=' Fpro shadow'
          variant='info'
          animated
          now={50}
        />
        <Modal.Header closeButton>
          <Button
            onClick={handleBack2}
            size='sm'
            className='btn-light Psbutton shadow'
          >
            <i className='fa fa-arrow-left' aria-hidden='true'></i>
          </Button>
        </Modal.Header>

        <Modal.Title className='text-center'>Select Lens</Modal.Title>
        <Modal.Body>
          {framebox.length === 0 ? (
            <ListGroup.Item>
              <Row>
                <h3>
                  Sorry, this product Does not have Frame Lens. Please Choose
                  Frame Only option
                </h3>
              </Row>
            </ListGroup.Item>
          ) : (
            <ListGroup variant='flush'>
              {framebox.map((lensdata) => (
                <ListGroup.Item>
                  <Row>
                    <Col md={3}>
                      <Button
                        className='btn-light Psbutton shadow'
                        style={{ verticalAlign: "middle" }}
                        size='sm'
                        onClick={() => {
                          setIsExpanded(!isExpanded);
                          SetId(lensdata._id);
                        }}
                      >
                        {isExpanded ? (
                          <i class='rotated-icon fa-solid fa-angles-left'></i>
                        ) : (
                          <i class='fa-solid fa-angles-left'></i>
                        )}
                      </Button>
                      <Button
                        size='sm'
                        onClick={() => {
                          Handleform3(`${lensdata._id}?${lensdata.price}`);
                        }}
                        className='Psbutton shadow btn-light ms-1'
                      >
                        Select this lens
                      </Button>
                    </Col>
                    <Col md={3}>{lensdata.name}</Col>
                    <Col md={3}>{lensdata.price}</Col>

                    <Col md={1}>
                      <Image
                        src={lensdata.image}
                        alt={product.name}
                        fluid
                        rounded
                      />
                    </Col>
                  </Row>
                  <Row>
                    <p className='my-2 FP'>{lensdata.description}</p>
                  </Row>
                </ListGroup.Item>
              ))}

              <ListGroup.Item>
                <h6 className='my-2 FP'>
                  Please choose the lens depending upon needs, budget face size
                  so it fits you perfectly
                </h6>
              </ListGroup.Item>
            </ListGroup>
          )}
        </Modal.Body>
      </Col>
    </>
  );
};

export default Case3;
